import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { RemoteServiceStore, RemoteServiceThresholdConfiguration } from '@store';

import { RemoteServiceService } from '../remote-service.service';

@Component({
  selector: 'app-remote-service-thresholds',
  templateUrl: './remote-service-thresholds.component.html',
  styleUrls: ['./remote-service-thresholds.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteServiceThresholdsComponent {
  @Input() thresholds: RemoteServiceThresholdConfiguration[];
  @Input() diagnosisGroup: string;
  @Input() thresholdsExpanded = false;
  @Output() thresholdsToggled = new EventEmitter<void>();

  constructor(
    public remoteServiceStore: RemoteServiceStore,
    public remoteServiceService: RemoteServiceService
  ) {}

  toggleThresholds(): void {
    this.thresholdsToggled.emit();
  }
}
